import React, { useLayoutEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { AgTechTourStep } from './AgTechTourTypes'

type Rect = { top: number; left: number; width: number; height: number }

const PADDING = 6

const AgTechTourOverlay = ({ step }: { step: AgTechTourStep }) => {
    const [rect, setRect] = useState<Rect | null>(null)

    useLayoutEffect(() => {
        const el = document.getElementById(step.targetId)
        if (el) {
            const r = el.getBoundingClientRect()
            setRect({ top: r.top, left: r.left, width: r.width, height: r.height })
        } else {
            setRect(null)
        }
    }, [step.targetId])

    const surface = document.getElementById('agtech-app') ?? document.body

    const vh = window.innerHeight

    const highlight = rect
        ? { top: rect.top - PADDING, left: rect.left - PADDING, width: rect.width + PADDING * 2, height: rect.height + PADDING * 2 }
        : null

    const overlay = (
        <>
            {highlight ? (
                <>
                    {/* top */}
                    <div className="fixed bg-black/50" style={{ bottom: vh - highlight.top, top: 0, left: 0, right: 0, zIndex: 9997 }} />
                    {/* bottom */}
                    <div className="fixed bg-black/50" style={{ top: highlight.top + highlight.height, left: 0, right: 0, bottom: 0, zIndex: 9997 }} />
                    {/* left */}
                    <div className="fixed bg-black/50" style={{ top: highlight.top, left: 0, width: highlight.left, height: highlight.height, zIndex: 9997 }} />
                    {/* right */}
                    <div className="fixed bg-black/50" style={{ top: highlight.top, left: highlight.left + highlight.width, right: 0, height: highlight.height, zIndex: 9997 }} />
                    {/* highlight ring */}
                    <div className="fixed rounded pointer-events-none" style={{ top: highlight.top, left: highlight.left, width: highlight.width, height: highlight.height, boxShadow: '0 0 0 2px white', zIndex: 9998 }} />
                </>
            ) : (
                <div className="fixed inset-0 bg-black/50" style={{ zIndex: 9997 }} />
            )}
        </>
    )

    return ReactDOM.createPortal(overlay, surface)
}

export default AgTechTourOverlay
